import { Dialog, DialogPanel } from '@headlessui/react'
import { X } from 'lucide-react'
import useModal from '../../hooks/useModal'
import { Button, Text } from '@oc-labs/wt-storybook'

export default function Drawer({ name, children, className, title = "Unknown", closeButton = true, backgroundColor = "bg-white", drawerWidth = "sm:w-[600px]" }) {
  const drawer = useModal(name)

  return (<Dialog open={drawer.isOpen} className="relative z-110" onClose={() => drawer.close()}>
    <div className="fixed inset-0" />

    <div className="fixed inset-0 overflow-hidden">
      <div className="absolute inset-0 overflow-hidden">
        <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full">
          <DialogPanel
            transition
            className={`w-[400px] ${drawerWidth} pointer-events-auto w-screen transform transition duration-500 ease-in-out data-closed:translate-x-full sm:duration-700`}
          >
            <div className={`flex h-full flex-col overflow-y-scroll ${backgroundColor} py-6 shadow-xl`}>

              {closeButton && (
                <div className="px-4 sm:px-6">
                  <div className="flex justify-between items-center">
                    <Text className="text-xl font-bold">{title}</Text>

                    <div>
                      <Button
                        type="tertiary"
                        className="h-8 w-8"
                        size="small"
                        onClick={() => drawer.close()}
                      >
                        <X className="h-4 w-4" />
                      </Button>
                    </div>
                  </div>
                </div>
              )}

              <div className={`relative flex-1 px-4 mt-4 sm:px-6 ${className || ''}`}>
                {children}
              </div>
            </div>
          </DialogPanel>
        </div>
      </div>
    </div>
  </Dialog>)
}
